module.exports = __webpack_public_path__ + "img/ruan1.898270c1.jpg";